import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useOperation } from "../../Context/OperationContext";
import style from "../../assets/jss/disal-main/Layouts/Operation";
import Grid from "@material-ui/core/Grid";
import RoomIcon from "@material-ui/icons/Room";
import Drawer from "@material-ui/core/Drawer";
import Map from "../../Component/MapsOperation";
import MapMobile from "../../Component/MapsOperationMobile";
import Slide from "../../Component/Slide/Slide";
import ContentOperation from "../../Component/Content/ContentOperation";
import ContentGeneral from "../../Component/Content/ContentGeneral";
import calendarIcon from "../../assets/img/calendario icon.svg";
import masIcon from "../../assets/img/add.svg";
import pendingIcon from "../../assets/img/pendientes icon.svg";
import checkIcon from "../../assets/img/check icon.svg";
import mapIcon from "../../assets/img/mundo icon.svg";
import Pagination from "../../Component/Pagination/PaginationReestructure";
import VerResultados from "./../../Component/Pagination/VerResultados";
import { getCurrentDate } from "../../Component/date";
import MiningSiteSelector from "./MiningSiteSelector";
const useStyles = makeStyles(style);
const MiningOperation = () => {
  const classes = useStyles();

  const {
    miningSite,
    operationData,
    open,
    infoOpen,
    infoOpenMobile,
    mapMobileOpen: openMap, // Rename to match existing code
    startIndex,
    endIndex,
    handleClickMap,
    onChangePage,
    handleInfoOpen,
    handleInfoOpenMobile,
    handleClickMapMobileOpen,
    handleClickMapMobileClose,
    fetchInitialData,
  } = useOperation();

  // Load initial data on component mount
  useEffect(() => {
    fetchInitialData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchInitialData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [miningSite]);
  
  // Default page limit for pagination
  const pageLimit = 10;

  // Calculate pagination data
  let rowsPerPage1 = [];
  let rowsPerPage2 = [];

  if (startIndex !== "" && endIndex !== "") {
    rowsPerPage1 = operationData.dataTableGeneral.slice(
      startIndex,
      endIndex + 1
    );
    rowsPerPage2 = operationData.dataTableById.slice(
      startIndex,
      endIndex + 1
    );
  }

  // Determine main content based on loading state and status table
  let mainContent;

  if (operationData.loading_data_Table) {
    mainContent = <div className="tabla-loader">
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>;
  } else if (operationData.statusTable !== "general") {
    mainContent = (
      <ContentOperation
        status={operationData.statusTable}
        open={open}
        pageOfItems={rowsPerPage2}
        miningSite={miningSite}
      />
    );
  } else {
    mainContent = (
      <ContentGeneral
        pageOfItems={rowsPerPage1}
        open={open}
      />
    );
  }

  const { date, monthNumber, year } = getCurrentDate();

  // Return the JSX for the component
  return (
    <Grid container className={classes.operation}>
      <Grid item md={12}>
        <div className={classes.boxTitle}>
          <h4>Monitoreo total de puntos generadores</h4>
          <p>
            <span>{date}</span>
            <span className={classes.slash}>/</span>
            <span>{monthNumber}</span>
            <span className={classes.slash}>/</span>
            <span>{year}</span>
          </p>
        </div>
      </Grid>
      <Grid item md={12}>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={3}
            className={classes.paddingRight}
          >
            <div className={classes.boxMonitoring + " bcgBlue"}>
              <div className="img-icons">
                <img src={calendarIcon} alt="Calendar Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">Programados</p>
                <p className="total-count">
                  <span>{operationData.total}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className={
              classes.paddingRight +
              " " +
              classes.paddingLeft
            }
          >
            <div className={classes.boxMonitoring + " bcgYellow"}>
              <div className="img-icons">
                <img src={pendingIcon} alt="Pendiente Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">Pendientes</p>
                <p className="total-count">
                  <span>{operationData.pending}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className={
              classes.paddingRight +
              " " +
              classes.paddingLeft
            }
          >
            <div className={classes.boxMonitoring + " bcgGreen"}>
              <div className="img-icons">
                <img src={checkIcon} alt="Check Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">Finalizados</p>
                <p className="total-count">
                  <span>{operationData.finished}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            className={classes.paddingLeft}
          >
            <div className={classes.boxMonitoring + " bcgRed"}>
              <div className="img-icons">
                <img src={masIcon} alt="Check Icon" />
              </div>
              <div className="info-monitoring">
                <p className="main-word">No programados</p>
                <p className="total-count">
                  <span>{operationData.noProgramated}</span>hoy
                </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <MiningSiteSelector />
      <Grid
        item
        sm={12}
        md={12}
        style={{ overflowX: "hidden" }}
        className={classes.slideStyle}
      >
        <Slide
          sliderWidth="220"
          sliderHeight="250"
        />
      </Grid>
      <Grid item xs={12} sm={12} className={classes.tableStyle}>
        <Grid container style={{ justifyContent: "space-between" }}>
          <Grid
            item
            sm={operationData.statusTable !== "general" ? 11 : 12}
            className={
              (open && operationData.statusTable !== "general" ? "otherStyle " : "") +
              classes.transtition
            }
          >
            <div className={classes.contentTitle}>
              <p className={classes.titleTable}>
                {operationData.statusTable === "general" && <span>Mostrando resultados de todos los vehículos</span>}
                {operationData.statusTable === "byId" && <span>Mostrando resultados para el vehículo {operationData.nameVehicle}</span>}
                {operationData.statusTable === "programated" && <span>Mostrando resultados de puntos no programados</span>}
              </p>
              <div className={classes.iconMap}>
                <button onClick={handleClickMapMobileOpen}>
                  <RoomIcon />
                </button>
              </div>
            </div>
            { mainContent }
            <div className={classes.infoPage}>
              <VerResultados
                rowsPerPage={
                  operationData.statusTable !== "general"
                    ? rowsPerPage2
                    : rowsPerPage1
                }
                totalRowsPerPage={
                  operationData.statusTable !== "general"
                    ? operationData.dataTableById
                    : operationData.dataTableGeneral
                }
              />
              <Pagination
                totalRecords={
                  operationData.statusTable !== "general"
                    ? operationData.dataTableById.length
                    : operationData.dataTableGeneral.length
                }
                pageLimit={pageLimit || 10}
                initialPage={1}
                pagesToShow={3}
                onChangePage={onChangePage}
              />
            </div>
          </Grid>
          {operationData.statusTable !== "general" && (
            <Grid
              item
              sm={1}
              className={
                classes.transtition +
                (open ? " otherStyle " : "")
              }
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  paddingLeft: "15px",
                }}
              >
                <div
                  className={
                    classes.btnSeeMap +
                    (open ? " otherStyleContent" : "")
                  }
                  onClick={handleClickMap}
                >
                  <p className={open ? " otherStyleMap" : ""}>
                    {open ? "OCULTAR MAPA" : "VER MAPA"}
                    <img src={mapIcon} alt="Map Icon " />
                  </p>
                </div>
                <div
                  className={classes.map}
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {operationData.loading_data_Table ? (
                    <div>load</div>
                  ) : (
                    <Map
                      handleInfoOpen={handleInfoOpen}
                      infoOpen={infoOpen}
                      google={{}} // Pass empty object as we don't have this.props.google anymore
                    />
                  )}
                </div>
              </div>
            </Grid>
          )}
        </Grid>
        {operationData.statusTable !== "general" && (
          <Drawer
            open={openMap}
            onClose={handleClickMapMobileClose}
            className={classes.mapaMobile}
          >
          <div></div>
          <MapMobile
            handleInfoOpen={handleInfoOpenMobile}
            infoOpen={infoOpenMobile}
            google={{}} // Pass empty object as we don't have this.props.google anymore
            open={openMap}
          />
        </Drawer>
        )}
      </Grid>
    </Grid>
  );
};

export default MiningOperation;